import React from 'react';
import DirectNavigationModel from '../DirectNavigationModel';
import {PropTypes} from 'prop-types';
import GroupsView from '../GroupsView/GroupsView.react';

import './StructureView.less';

class StructureView extends React.PureComponent {
    _onGroupClick = (group) => {
        if (this.props.onGroupClick) {
            this.props.onGroupClick(group, this.props.structure);
        }
    };

    _onSpaceClick = (space, group) => {
        if (this.props.onSpaceClick) {
            this.props.onSpaceClick(space, group, this.props.structure);
        }
    };

    render() {
        // TODO: Display for Structure index?
        let style = this.props.active ? {} : {display: 'none'};
        return (
            <li className={'Structure'} style={style}>
                <GroupsView
                    groups={this.props.structure.groups}
                    onSpaceClick={this._onSpaceClick}
                    onGroupClick={this._onGroupClick}
                />
            </li>
        );
    }
}

StructureView.propTypes = {
    structure: DirectNavigationModel.structureType.isRequired,
    active: PropTypes.bool.isRequired,
    onGroupClick: PropTypes.func,
    onSpaceClick: PropTypes.func,
};

export default StructureView;
